import { Box } from '@mui/material';
import { AccountMenuButton } from './AccountMenuButton';
import { PageTitle } from './PageTitle';
import { useRouteTitle } from './useRouteTitle';

/** Mobile chrome header: page `h1` + avatar (account sheet). */
export const MobileHeader = () => {
  const title = useRouteTitle();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
        px: 2,
        pt: 1.5,
        pb: 0,
        flexShrink: 0,
      }}
    >
      <PageTitle title={title} fontSize={23} noWrap />
      <AccountMenuButton size={38} />
    </Box>
  );
};
